import {OptionType} from 'platform/components';

import {TemplateTypeEnum} from '@dms/api/core';
import {i18n} from '@dms/i18n';

import {buildArray} from 'shared/web';

export const getContextOptions = (type: TemplateTypeEnum) =>
  buildArray<OptionType>()
    .add({
      value: 'customer',
      label: i18n.t('page.messageTemplates.labels.contextOptions.customer'),
    })
    .add({
      value: 'service-order',
      label: i18n.t('page.messageTemplates.labels.contextOptions.serviceOrder'),
    })
    .add({
      value: 'business-case',
      label: i18n.t('page.messageTemplates.labels.contextOptions.businessCase'),
    })
    .when(type !== 'chat', {
      value: 'rental-order',
      label: i18n.t('page.messageTemplates.labels.contextOptions.rentalOrder'),
    })
    .when(type !== 'chat', {
      value: 'vehicle',
      label: i18n.t('page.messageTemplates.labels.contextOptions.vehicle'),
    })
    .add({
      value: 'interest',
      label: i18n.t('page.messageTemplates.labels.contextOptions.interest'),
    })
    .when(type !== 'chat', {
      value: 'workshop-interest',
      label: i18n.t('page.messageTemplates.labels.contextOptions.workshopInterest'),
    })
    .when(type !== 'chat', {
      value: 'tire-set',
      label: i18n.t('entity.tireSet.labels.tireSet'),
    });
